import {AppUrls} from 'shared/config/model/urls';

import cn from 'classnames';
import React, {useCallback} from 'react';

import LogoBannerBrotherhood from 'shared/ui/icons/LogoBannerBrotherhood';
import PlusInBanner from 'shared/ui/icons/PlusInBanner';
import {reachGoal, YM_GOALS} from 'shared/lib/analytics';

import styles from './BrotherhoodBanner.module.scss';

const BrotherhoodBanner: React.FC = () => {

    const getRandomBanner = () => {
        const today = new Date();
        const start = new Date(today.getFullYear(), 0, 0);
        const diff = today.getTime() - start.getTime();
        const oneDay = 1000 * 60 * 60 * 24;
        const dayOfYear = Math.floor(diff / oneDay);

        return dayOfYear % 4;
    };

    const bannerIndex = getRandomBanner();

    const onBannerClick = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        reachGoal(YM_GOALS.CLICK_BANNER_BROTHERHOOD);
    }, []);

    const bannerTexts = [
        'Понравился Overseer? Мы можем разработать веб‑проект и для вас!',
        'Понравился Overseer? Мы можем взять на себя поддержку вашего сайта',
        'Устраняем проблемы, которые выявляет Overseer!',
        'Overseer находит проблему, а мы можем её устранить.',
    ];

    return (
        <a href={AppUrls.BROTHERHOOD} target="_blank" rel="noopener noreferrer" onClick={onBannerClick}>
            <div className={cn(styles.container, {
                [styles.withGradient]: bannerIndex === 0,
                [styles.withImage]: bannerIndex !== 0,
            })}>
                <span><LogoBannerBrotherhood/></span>
                <span className={styles.text}>
                    {bannerTexts[bannerIndex]}
                </span>
                <span className={styles.icon}>
                    {bannerIndex === 0 && (
                        <span className={styles.icon}>
                            <PlusInBanner width={12} height={12}/>
                        </span>
                    )}
                </span>
            </div>
        </a>
    );
};

export default BrotherhoodBanner;